import sortInsurance from 'utils/sortInsurance';

const selectInsurance = insurance =>
  sortInsurance(insurance)[0];

export default selectInsurance;



// WEBPACK FOOTER //
// ./src/utils/selectInsurance.js